import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

export interface PublicLoyaltyCardProgress {
  kind: string;
  label: string;
  stamps_count: number;
  stamps_required: number | null;
  remaining_to_reward: number | null;
  free_credits: number;
  reward_validity_days?: number | null;
}

export interface PublicLoyaltyProgress {
  studio_name?: string | null;
  client_first_name?: string | null;
  cards: PublicLoyaltyCardProgress[];
  expires_at: number;
}

export const getPublicLoyaltyProgress = (
  token: string
): Promise<ApiResponse<PublicLoyaltyProgress>> =>
  api.get<ApiResponse<PublicLoyaltyProgress>>(
    `/public/loyalty/${encodeURIComponent(token)}`
  );
